import { useSelector, useDispatch } from 'react-redux';
import { useForm, Controller } from "react-hook-form";
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { classNames } from 'primereact/utils';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import { Button } from '../../../components/ui/Button';

import { useDeleteCampaignMutation, useUpdateCampaignMutation } from '../../../queries';
import { campaignStatusOptions } from '../../../config/constants';
import { getFormErrorMessage } from '../../../config/global';
import { toggleDialog } from '../../../redux/Slices/Global/globalSlice';
import { useDataTableContext } from '../../Contexts/DataTableContext';
import { useCustomToast } from '../../Contexts/ToastContext';

const UsageAndConfirmation = ({ campaignUsage, campaign }) => {
    const { t } = useTranslation();
    const { control, formState: { errors }, handleSubmit, reset, } = useForm()
    const deleteCampaign = useDeleteCampaignMutation();
    const openDialog = useSelector((state) => state.global.openDialog);
    const { setLazyParams } = useDataTableContext();
    const dispatch = useDispatch()
    const { showToast } = useCustomToast();

    useEffect(() => {
        reset(campaign)
    }, [campaign])

    const onSubmit = async () => {
        await deleteCampaign.mutateAsync({
            id: campaign.id,

        }, {
            onSuccess: () => {
                dispatch(toggleDialog("usageAndConfirmation"))
            }
        })
    };



    const onClose = () => dispatch(toggleDialog("usageAndConfirmation"))


    const renderFooter = () => {
        return (
            <div className="flex   w-full  justify-end">
                <Button
                    label={t('buttons.cancel')}
                    className="py-1 p-button-text p-button-secondary"
                    onClick={onClose}
                    disabled={deleteCampaign.isLoading}
                />
                <Button
                    label={t('buttons.yes')}
                    className="py-1"
                    onClick={onSubmit}
                    loading={deleteCampaign.isLoading}
                    disabled={deleteCampaign.isLoading}
                />
            </div>
        )
    }
    return (
        <Dialog
            id='assignDeviceDialog'

            visible={openDialog.usageAndConfirmation}
            breakpoints={{ '960px': '95vw' }}
            style={{ width: '600px', minHeight: "300px" }}
            header={t('show.show_delete_campaign')}
            modal
            footer={renderFooter}
            className="p-fluid  "
            onHide={() => dispatch(toggleDialog("usageAndConfirmation"))}
        >
            <div className='flex flex-col justify-center h-100 my-2 w-100 items-center'>
                <div className="text-center">
                    <i className="mt-3 pi pi-exclamation-triangle mr-3 d-block" style={{ fontSize: '2rem' }} />
                    <br />
                    <span>{t('show.show_confirm_delete_prefix')}</span>
                    {campaign.name.length > 20 ?
                        <>
                            <br /> <b>{campaign.name} </b>?
                        </> : <>
                            <b>{campaign.name} </b>?
                        </>}
                </div>

                {campaignUsage ? (
                    <div className="   ">
                        {/* Usage Summary */}

                        <div className="mx-5 my-2 text-center  font-semibold text-gray-800">
                            {t('show.show_assigned_devices', { count: campaignUsage.length })}{campaignUsage.length > 0 ? ":" : "."}
                        </div>
                        <div className="mb-3 justify-center flex mx-5">

                            {campaignUsage.map(
                                (section, idx) =>

                                    <div className="gap-1 flex px-1  text-start   text-gray-700">
                                        {/* <span>• </span> */}
                                        {section}{idx < campaignUsage.length - 1 ? "," : "."}

                                    </div>


                            )}
                        </div>
                    </div>
                ) : null}



            </div>
        </Dialog >
    )
}
export default UsageAndConfirmation;